import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle, Image, CheckCircle, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProfileRequirementsModalProps {
  isOpen: boolean;
  onClose: () => void;
  missingRequirements: string[];
}

export const ProfileRequirementsModal: React.FC<ProfileRequirementsModalProps> = ({
  isOpen,
  onClose,
  missingRequirements
}) => {
  const navigate = useNavigate();

  const handleCompleteProfile = () => {
    onClose();
    navigate('/main/profile');
  };

  const handleVerify = () => {
    onClose();
    navigate('/main/verify');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-black border-white/20 text-white max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-luxury-red/20">
              <AlertCircle className="h-6 w-6 text-luxury-red" />
            </div>
            <DialogTitle className="text-xl">Complete seu perfil para usar o chat</DialogTitle>
          </div>
          <DialogDescription className="text-gray-400">
            Para garantir a segurança e qualidade das interações, você precisa completar os seguintes requisitos:
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 my-4">
          {missingRequirements.map((requirement, index) => (
            <div key={index} className="flex items-start gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
              <div className="mt-0.5">
                {requirement.includes('foto') && <Image className="h-5 w-5 text-luxury-red" />}
                {requirement.includes('perfil') && <CheckCircle className="h-5 w-5 text-luxury-red" />}
                {requirement.includes('Verifique') && <Shield className="h-5 w-5 text-luxury-red" />}
              </div>
              <p className="text-sm text-gray-200">{requirement}</p>
            </div>
          ))}
        </div>

        <div className="flex gap-3 mt-6">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-white/20 text-white hover:bg-white/10"
          >
            Depois
          </Button>
          {missingRequirements.some(r => r.includes('Verifique')) ? (
            <Button
              onClick={handleVerify}
              className="flex-1 bg-luxury-red hover:bg-luxury-red/90"
            >
              Verificar Agora
            </Button>
          ) : (
            <Button
              onClick={handleCompleteProfile}
              className="flex-1 bg-luxury-red hover:bg-luxury-red/90"
            >
              Completar Perfil
            </Button>
          )}
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          Estes requisitos ajudam a manter a plataforma segura e confiável para todos.
        </p>
      </DialogContent>
    </Dialog>
  );
};
